const auth_status = {
    page_title: 'حالة المصادقة',
    title: 'حالة المصادقة',
    description: 'تحقق من حالة المصادقة.',
};
export default Object.freeze(auth_status);
